import { DraggableWindow } from './DraggableWindow.js';
import { windowContentLoader } from './windowContentLoader.js';
import { CollapsibleManager } from './CollapsibleManager.js';
import { VimMode } from './VimMode.js';
import { CursorPosition } from './CursorPosition.js';
import { ThemeToggle } from './ThemeToggle.js';

document.addEventListener('DOMContentLoaded', function() {
    const contentLoader = new windowContentLoader();
    new DraggableWindow(document.querySelector('#mainWindow'));

    const readmeButton = document.querySelector('#load-readme');
    const projectsButton = document.querySelector('#load-projects');
    const contactButton = document.querySelector('#load-contact');

    // Which buffer is open, shown the way a file manager shows it: the entry
    // stays highlighted.
    function markActive(button) {
        [readmeButton, projectsButton, contactButton].forEach((candidate) => {
            const active = candidate === button;
            candidate.classList.toggle('is-active', active);
            if (active) {
                candidate.setAttribute('aria-current', 'true');
            } else {
                candidate.removeAttribute('aria-current');
            }
        });
    }

    function loadReadme() {
        markActive(readmeButton);
        contentLoader.loadContent('README.html', 'README.txt').then(() => {
            new CollapsibleManager('.collapsible');
        });
    }

    function loadProjects() {
        markActive(projectsButton);
        contentLoader.loadContent('projects.html');
    }

    function loadContact() {
        markActive(contactButton);
        contentLoader.loadContent('contact.html');
    }

    
    new ThemeToggle(document.querySelector('#toggle-theme'));
    new CursorPosition(document.querySelector('#mainWindow'));
    new VimMode({
        element: document.querySelector('#mainWindow'),
        buffers: { readme: loadReadme, projects: loadProjects, contact: loadContact },
    });

    readmeButton.addEventListener('click', loadReadme);
    projectsButton.addEventListener('click', loadProjects);
    contactButton.addEventListener('click', loadContact);
    loadReadme(); // Hi! :)
}, false);
